import React from 'react';
import { useTranslation } from 'utils/i18n';

// Import extracted logic
import { usePressUI } from './logic/ui';
import translations from './translations';

/**
 * Press Component
 * Displays press information
 */
const Press = () => {
  const { language, t: tCommon } = useTranslation();
  const { handlePressReleaseClick, handleMediaItemClick, handlePressMentionClick, getTranslationArray } = usePressUI(tCommon);

  // Get page-specific translations
  const t = (key, defaultValue = '') => {
    const pageTranslations = translations[language] || translations.en;
    const value = key.split('.').reduce((obj, k) => obj?.[k], pageTranslations);
    if (value !== undefined && value !== null && value !== '') {
      return value;
    }
    return defaultValue !== '' ? defaultValue : key;
  };

  return (
    <div className="static-page">
      <div className="static-page-header">
        <div className="static-page-header-content">
          <div className="page-title-section">
            <h1>{t('title', 'Press')}</h1>
            <p className="lead">
              {t('description', 'Press information, press releases and media resources')}
            </p>
          </div>
        </div>
      </div>

      <div className="static-page-content">
        <section className="content-section">
          <div className="press-contact-card">
            <h2>{t('pressContact.heading', 'Press Contact')}</h2>
            <div className="press-contact-info">
              <h3>{t('pressContact.name', 'Press Team')}</h3>
              <p className="press-contact-title-role">{t('pressContact.title', 'Media Relations')}</p>
              <div className="press-contact-details">
                <p><strong>{t('pressContact.emailLabel', 'Email')}:</strong> {t('pressContact.email', 'press@b-esper.com')}</p>
                <p><strong>{t('pressContact.phoneLabel', 'Phone')}:</strong> {t('pressContact.phone', '+49 171 67 24 126')}</p>
              </div>
              <p>
                {t('pressContact.description', 'For media inquiries, press releases, and media kit requests, please contact our press team.')}
              </p>
            </div>
          </div>
        </section>

        <section className="content-section">
          <h2>{t('pressReleases.heading', 'Press Releases')}</h2>
          <div className="press-releases-grid">
            {getTranslationArray('pressReleases.items').map((release, index) => (
              <div key={index} className="press-release-card" onClick={() => handlePressReleaseClick(release.title)}>
                <div className="press-release-date">{release.date}</div>
                <h3>{release.title}</h3>
                <p>{release.summary}</p>
                <a href={release.link} className="read-more">{t('pressReleases.readMore', 'Read more')} →</a>
              </div>
            ))}
          </div>
        </section>

        <section className="content-section">
          <h2>{t('pressMentions.heading', 'Press Mentions')}</h2>
          <div className="press-mentions-grid">
            {getTranslationArray('pressMentions.items').map((mention, index) => (
              <div key={index} className="press-mention-card" onClick={() => handlePressMentionClick(mention.title)}>
                <div className="press-mention-source">{mention.source}</div>
                <h3>{mention.title}</h3>
                <p>{mention.excerpt}</p>
                <a href={mention.link} className="read-more">{t('pressMentions.readMore', 'Read article')} →</a>
              </div>
            ))}
          </div>
        </section>

        <section className="content-section">
          <h2>{t('mediaResources.heading', 'Media Resources')}</h2>
          <div className="press-media-grid">
            {getTranslationArray('mediaResources.items').map((item, index) => (
              <div key={index} className="press-media-card" onClick={() => handleMediaItemClick(item.name)}>
                <h3>{item.name}</h3>
                <p>{item.description}</p>
                <a href={item.downloadUrl} className="read-more">{t('mediaResources.download', 'Download')} →</a>
              </div>
            ))}
          </div>
        </section>
      </div>
    </div>
  );
};

export default Press;


